const bugsnagJS = require('bugsnag-js')
const bugsnagClient = bugsnagJS('55ba451df1a05e63504f2a3ac9cdc0ba')
const bugsnagVue = require('bugsnag-vue')

/**
 * Configure bugsnag for use with Vue.
 *
 * @export
 * @param {*} Vue A reference to the Vue library.
 */
export function bugsnag (Vue) {
  Vue.use(bugsnagClient)
  bugsnagClient.use(bugsnagVue(Vue))
  window.bugsnagClient = bugsnagClient
}
